export default __webpack_public_path__ + "static/media/11.a807aca0.png";